import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { useTranslation } from "react-i18next";
import { Mosaic } from "react-loading-indicators";

// ─── INDUSTRIES ───────────────────────────────────────────────────────────────
const INDUSTRIES = [
  { emoji: "🪒", key: "industry_barbershop", value: "Barbershop / Men's Salon" },
  { emoji: "💅", key: "industry_salon_femme", value: "Beauty Salon / Hair Salon" },
  { emoji: "💆", key: "industry_spa", value: "Spa & Wellness" },
  { emoji: "💪", key: "industry_gym", value: "Gym / Fitness" },
  { emoji: "🍽️", key: "industry_restaurant", value: "Restaurant" },
  { emoji: "☕", key: "industry_cafe", value: "Café / Bakery" },
  { emoji: "🥤", key: "industry_juice_bar", value: "Juice Bar / Fast Food" },
  { emoji: "🏥", key: "industry_clinic", value: "Clinic / Medical" },
  { emoji: "🦷", key: "industry_dentist", value: "Dentist" },
  { emoji: "🌿", key: "industry_pharmacy", value: "Pharmacy / Herbal" },
  { emoji: "👶", key: "industry_childcare", value: "Childcare / Nursery" },
  { emoji: "🎓", key: "industry_academy", value: "Academy / School / Training" },
  { emoji: "⛪", key: "industry_church", value: "Church / Mosque / Religion" },
  { emoji: "🤝", key: "industry_ngo", value: "NGO / Charity / Association" },
  { emoji: "🔧", key: "industry_plumber", value: "Plumber" },
  { emoji: "⚡", key: "industry_electrician", value: "Electrician" },
  { emoji: "❄️", key: "industry_hvac", value: "HVAC / Air Conditioning" },
  { emoji: "🏗️", key: "industry_construction", value: "Construction / Contractor" },
  { emoji: "🪟", key: "industry_carpenter", value: "Carpenter / Furniture" },
  { emoji: "🚗", key: "industry_carwash", value: "Car Wash / Auto Detailing" },
  { emoji: "🔩", key: "industry_auto_repair", value: "Auto Repair / Garage" },
  { emoji: "🚙", key: "industry_car_dealer", value: "Car Dealership / Auto Sales" },
  { emoji: "🚛", key: "industry_transport", value: "Transport / Logistics / Delivery" },
  { emoji: "💻", key: "industry_tech", value: "Tech / Agency / Startup" },
  { emoji: "📱", key: "industry_mobile_repair", value: "Mobile Repair" },
  { emoji: "🏪", key: "industry_retail", value: "General Store / Retail" },
  { emoji: "👗", key: "industry_boutique", value: "Boutique / Fashion" },
  { emoji: "🏨", key: "industry_hotel", value: "Hotel / Guesthouse" },
  { emoji: "📸", key: "industry_photography", value: "Photography / Events" },
  { emoji: "💰", key: "industry_finance", value: "Finance / Insurance" },
  { emoji: "🏠", key: "industry_real_estate", value: "Real Estate" },
  { emoji: "⚙️", key: "industry_other", value: "Other" },
];

export default function Home() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const [businessName, setBusinessName] = useState('');
  const [businessType, setBusinessType] = useState('');
  const [businessTypeOther, setBusinessTypeOther] = useState('');
  const [businessDescription, setBusinessDescription] = useState('');
  const [businessAddress, setBusinessAddress] = useState('');
  const [businessEmail, setBusinessEmail] = useState('');
  const [businessPhone, setBusinessPhone] = useState('');
  const [language, setLanguage] = useState('');
  const [step, setStep] = useState(0);
  const [inputReply, setInputReply] = useState('');
  const [showInputReply, setShowInputReply] = useState('none');
  const [showSpinner, setShowSpinner] = useState('none');
  const [firebaseUserInfo] = useState(JSON.parse(localStorage.getItem('firebase_user')));
  const [longueur, setLongueur] = useState('0%');
  const [taskStatus, setTaskStatus] = useState(t("ai-wizard.msg_task_status1"));
  const [showModalLoader, setShowModalLoader] = useState('none');
  const [isGenerating, setIsGenerating] = useState(false);
  const progressIntervalRef = useRef(null);

  const TOTAL_STEPS = 7;

  useEffect(() => {
    if (!localStorage.getItem('user_info')) navigate('/login');
    if (JSON.parse(localStorage.getItem('user_info')).credit == 0) navigate('/dashboard');
  }, []);
  
  
  
  

  useEffect(() => {
	  
	  
	 // alert(i18n.language);
	  
    const handleBeforeUnload = () => {
      if (isGenerating) {
        localStorage.setItem('zuribuild_generating', JSON.stringify({ businessName, timestamp: Date.now() }));
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [isGenerating, businessName]);

  const progress = ((step + 1) / TOTAL_STEPS) * 100;

  // ─── PROGRESS BAR ──────────────────────────────────────────────────────────
  const startFakeProgress = () => {
    setLongueur('5%');
    let current = 5;
    progressIntervalRef.current = setInterval(() => {
      current += Math.random() * 3;
      if (current >= 90) { current = 90; clearInterval(progressIntervalRef.current); }
      setLongueur(current + '%');
      if (current < 30) setTaskStatus(t("ai-wizard.msg_task_status1"));
      else if (current < 60) setTaskStatus(t("ai-wizard.msg_task_status2"));
      else setTaskStatus(t("ai-wizard.msg_task_status3"));
    }, 900);
  };

  const finishProgress = () => { clearInterval(progressIntervalRef.current); setLongueur('100%'); setTaskStatus('✅ Done!'); };
  const resetProgress = () => { clearInterval(progressIntervalRef.current); setLongueur('0%'); setShowModalLoader('none'); setIsGenerating(false); localStorage.removeItem('zuribuild_generating'); };

  // ─── VALIDATION PER STEP ───────────────────────────────────────────────────
  const showError = (msg) => { setShowInputReply('flex'); setInputReply(msg); };
  const clearError = () => { setShowInputReply('none'); setInputReply(''); };

  const handleNext = () => {
    if (step === 0) {
      if (!businessName.trim()) { showError(t("ai-wizard.alert_filled")); return; }
      checkBusinessName();
      return;
    }
    if (step === 1) {
      if (!businessType) { showError(t("ai-wizard.alert_required_field")); return; }
      clearError(); setStep(s => s + 1); return;
    }
    if (step === 2) {
      // description optional — just go next
      clearError(); setStep(s => s + 1); return;
    }
    if (step === 3) {
      if (!businessAddress.trim()) { showError(t("ai-wizard.alert_required_field")); return; }
      clearError(); setStep(s => s + 1); return;
    }
    if (step === 4) {
      if (!businessEmail.trim()) { showError(t("ai-wizard.alert_required_field")); return; }
      clearError(); setStep(s => s + 1); return;
    }
    if (step === 5) {
      if (!businessPhone.trim()) { showError(t("ai-wizard.alert_required_field")); return; }
      clearError(); setStep(s => s + 1); return;
    }
  };

  const handleBack = () => { clearError(); if (step > 0) setStep(s => s - 1); };

  const checkBusinessName = async () => {
    setShowSpinner('inline-block');
    try {
      const res = await axios.post(process.env.REACT_APP_PHP_API_URL + "/zuribuildAPI/search-website.php",
        { website_name: businessName },
        { headers: { "Content-Type": "application/json" } }
      );
      setShowSpinner('none');
      if (res.data == 'Business no found') { clearError(); setStep(1); }
      else { showError(t("ai-wizard.msg_input_reply")); }
    } catch (err) {
      setShowSpinner('none');
      toast.error(err.message, { position: 'bottom-right' });
    }
  };

  function normalizeBusinessName(name) {
    const words = name.trim().split(/\s+/).filter(Boolean);
    return words.length > 1 ? words.join("-") : words[0];
  }

  // ─── GENERATE ──────────────────────────────────────────────────────────────
  const createNewWebsite = async () => {
    if (!language) { showError(t("ai-wizard.alert_required_field")); return; }
    setShowModalLoader('block');
    setIsGenerating(true);
    startFakeProgress();
    localStorage.setItem('zuribuild_generating', JSON.stringify({ businessName, timestamp: Date.now() }));

    const finalBusinessType = businessType === 'Other' ? businessTypeOther : businessType;

    try {
      const response = await fetch(process.env.REACT_APP_NODE_MIDDLEWARE_API_URL + "/api/generate", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          businessName,
          businessType: finalBusinessType,
          businessDescription,
          businessAddress,
          businessEmail,
          businessPhone,
          businessWhatsapp: businessPhone,
          language,
          member_id: firebaseUserInfo.uid,
          userEmail: firebaseUserInfo.email,
          appLanguage: i18n.language || 'fr',
        })
      });

      const data = await response.json();

      if (data.success) {
        finishProgress();
        localStorage.removeItem('zuribuild_generating');
        localStorage.setItem('url_site', data.url);
        localStorage.setItem('last_folder_name', data.folderName);
        setTimeout(() => { setShowModalLoader('none'); setIsGenerating(false); navigate("/success"); }, 800);
      } else {
        resetProgress();
        toast.error(data.message || "Generation failed. Please try again.", { position: 'bottom-right' });
      }
    } catch (error) {
      resetProgress();
      toast.error("Server error. Please try again.", { position: 'bottom-right' });
    }
  };

  // ─── STEP TITLE ────────────────────────────────────────────────────────────
  const getStepTitle = () => {
    switch(step) {
      case 0: return t("ai-wizard.question_lets_get");
      case 1: return t("ai-wizard.question_which_type");
      case 2: return t("ai-wizard.question_description");
      case 3: return t("ai-wizard.question_location");
      case 4: return t("ai-wizard.question_email");
      case 5: return t("ai-wizard.question_phone");
      case 6: return t("ai-wizard.question_language");
      default: return '';
    }
  };

  return (
    <>
      <style>{`
        body { margin: 0; font-family: 'Inter', -apple-system, sans-serif; background-color: #fff; color: #000; }
        .header { display: flex; justify-content: space-between; align-items: center; padding: 20px; background-color: white; }
        .logo { font-size: 26px; font-weight: 800; color: var(--secondary-red); letter-spacing: -1px; text-decoration: none; }
        .step-label { font-size: 14px; font-weight: 550; color: #555; }
        .progress-bar-wrap { width: 100vw; height: 4px; background-color: rgb(228,228,230); }
        #progress-indicator { height: 4px; background-color: black; transition: width 0.6s ease; }
        .container { display: flex; justify-content: center; align-items: flex-start; padding: 40px 20px; min-height: 60vh; }
        .content { width: 100%; max-width: 560px; }
        h2 { margin-bottom: 20px; font-size: 22px; color: #000; font-weight: 700; }
        .input-box { width: 100%; height: 50px; border-radius: 25px; border: 1px solid #ccc; padding: 0 15px; font-size: 16px; margin-bottom: 20px; box-sizing: border-box; outline: none; }
        .input-box:focus { border-color: #7C3AED; }
        .btn { width: 100%; height: 50px; border-radius: 25px; border: none; background-color: #7C3AED; color: white; font-size: 16px; cursor: pointer; transition: 0.3s; margin-top: 8px; }
        .btn:hover { background-color: #5a0e8f; }
        .btn:disabled { opacity: 0.6; cursor: not-allowed; }
        .fade { opacity: 0; transform: translateY(10px); animation: fadeIn 0.5s ease forwards; }
        @keyframes fadeIn { to { opacity: 1; transform: translateY(0); } }

        /* Industry Grid */
        .industry-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px; margin-bottom: 20px; }
        .industry-card { border: 2px solid #eee; border-radius: 12px; padding: 12px 8px; text-align: center; cursor: pointer; transition: all 0.15s; background: white; }
        .industry-card:hover { border-color: #7C3AED; background: #f3f0ff; }
        .industry-card.selected { border-color: #7C3AED; background: #f3f0ff; }
        .industry-emoji { font-size: 24px; display: block; margin-bottom: 4px; }
        .industry-label { font-size: 11px; color: #333; font-weight: 500; line-height: 1.3; }

        /* Language Buttons */
        .lang-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-bottom: 20px; }
        .lang-btn { border: 2px solid #eee; border-radius: 16px; padding: 20px; text-align: center; cursor: pointer; transition: all 0.15s; background: white; font-size: 32px; }
        .lang-btn:hover { border-color: #7C3AED; background: #f3f0ff; }
        .lang-btn.selected { border-color: #7C3AED; background: #f3f0ff; }
        .lang-name { font-size: 15px; font-weight: 700; color: #333; margin-top: 8px; }
        .lang-sub { font-size: 12px; color: #aaa; margin-top: 2px; }

        /* Description textarea */
        .textarea-box { width: 100%; border-radius: 16px; border: 1px solid #ccc; padding: 14px 16px; font-size: 15px; margin-bottom: 20px; box-sizing: border-box; outline: none; resize: vertical; min-height: 120px; font-family: inherit; line-height: 1.5; }
        .textarea-box:focus { border-color: #7C3AED; }
        .optional-label { font-size: 12px; color: #aaa; margin-bottom: 8px; display: block; }

        @media (max-width: 767px) {
          .content { width: 100%; }
          .industry-grid { grid-template-columns: repeat(3, 1fr); gap: 8px; }
          .industry-card { padding: 10px 6px; }
          .industry-emoji { font-size: 20px; }
          .industry-label { font-size: 10px; }
          #loader-bar-modal { width: 85vw !important; margin-top: 35vh !important; }
        }
      `}</style>

      {/* Header */}
      <header className="header">
        <Link to="/dashboard" style={{ textDecoration: 'none' }}>
          <div className="logo">
            <img src="/zuribuild.png" style={{ width: '40px' }} alt="logo" />
            ZuriBuild
          </div>
        </Link>
        <div className="step-label">{t("ai-wizard.step")} {step + 1} {t("ai-wizard.of")} {TOTAL_STEPS}</div>
      </header>

      {/* Progress Bar */}
      <div className="progress-bar-wrap">
        <div id="progress-indicator" style={{ width: progress + '%' }} />
      </div>

      <button style={{ marginTop: '20px', marginLeft: '20px', background: '#f0f0f0', padding: '6px 14px', fontWeight: 'bold', fontSize: '14px', borderRadius: '8px', border: '0px', cursor: 'pointer' }}>
        <Link className="dropdown-item" to="/dashboard" style={{ textDecoration: 'none', color: '#333' }}>{t("header.main_menu")}</Link>
      </button>

      {/* Body */}
      <div className="container">
        <div className="content">
          {step > 0 && (
            <button onClick={handleBack} style={{ display: 'flex', alignItems: 'center', gap: 6, fontWeight: 'bold', marginLeft: '-10px', color: 'gray', fontSize: '15px', border: '0px', backgroundColor: 'transparent', cursor: 'pointer', marginBottom: 8 }}>
              <i style={{ color: 'black', fontSize: '26px' }} className="bi bi-arrow-left" />
              <span>{t("ai-wizard.btn_back")}</span>
            </button>
          )}

          <div key={step} className="fade">
            <h2>{getStepTitle()}</h2>

            {/* Step 0 — Business Name */}
            {step === 0 && (
              <input
                type="text"
                className="input-box"
                placeholder={t("ai-wizard.placeholder_zuribuild")}
                value={businessName}
                onChange={(e) => setBusinessName(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleNext()}
              />
            )}

            {/* Step 1 — Industry Dropdown */}
            {step === 1 && (
              <>
                <select
                  className="input-box"
                  value={businessType}
                  onChange={(e) => { setBusinessType(e.target.value); clearError(); }}
                  style={{ appearance: 'auto', cursor: 'pointer' }}
                >
                  <option value="">— {t("ai-wizard.placeholder_select_industry")} —</option>
                  {INDUSTRIES.map((ind) => (
                    <option key={ind.key} value={ind.value}>
                      {ind.emoji} {t("ai-wizard." + ind.key)}
                    </option>
                  ))}
                </select>
                {businessType === 'Other' && (
                  <input
                    type="text"
                    className="input-box"
                    placeholder={t("ai-wizard.placeholder_other_industry")}
                    value={businessTypeOther}
                    onChange={(e) => setBusinessTypeOther(e.target.value)}
                  />
                )}
              </>
            )}

            {/* Step 2 — Business Description */}
            {step === 2 && (
              <>
                <span className="optional-label">{t("ai-wizard.optional")}</span>
                <textarea
                  className="textarea-box"
                  placeholder={t("ai-wizard.placeholder_description")}
                  value={businessDescription}
                  onChange={(e) => setBusinessDescription(e.target.value)}
                />
              </>
            )}

            {/* Step 3 — Location */}
            {step === 3 && (
              <input
                type="text"
                className="input-box"
                placeholder={t("ai-wizard.placeholder_city")}
                value={businessAddress}
                onChange={(e) => setBusinessAddress(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleNext()}
              />
            )}

            {/* Step 4 — Email */}
            {step === 4 && (
              <input
                type="email"
                className="input-box"
                placeholder={t("ai-wizard.placeholder_email")}
                value={businessEmail}
                onChange={(e) => setBusinessEmail(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleNext()}
              />
            )}

            {/* Step 5 — Phone */}
            {step === 5 && (
              <input
                type="tel"
                className="input-box"
                placeholder={t("ai-wizard.placeholder_phone")}
                value={businessPhone}
                onChange={(e) => setBusinessPhone(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleNext()}
              />
            )}

            {/* Step 6 — Language */}
            {step === 6 && (
              <div className="lang-grid">
                <div
                  className={`lang-btn ${language === 'fr' ? 'selected' : ''}`}
                  onClick={() => { setLanguage('fr'); clearError(); }}
                >
                  🇫🇷
                  <div className="lang-name">Français</div>
                  <div className="lang-sub">French</div>
                </div>
                <div
                  className={`lang-btn ${language === 'en' ? 'selected' : ''}`}
                  onClick={() => { setLanguage('en'); clearError(); }}
                >
                  🇬🇧
                  <div className="lang-name">English</div>
                  <div className="lang-sub">Anglais</div>
                </div>
              </div>
            )}
          </div>

          {/* Error message */}
          <div style={{ color: 'red', display: showInputReply, marginBottom: 8, fontSize: 14 }}>{inputReply}</div>

          {/* Next / Generate button */}
          {step < TOTAL_STEPS - 1 ? (
            <button className="btn" onClick={handleNext}>
              {t("ai-wizard.btn_next")}
              <div className="spinner-grow spinner-grow-sm" role="status" style={{ marginLeft: '10px', display: showSpinner }} />
            </button>
          ) : (
            <button className="btn" onClick={createNewWebsite} disabled={isGenerating}>
              {t("ai-wizard.btn_finish")}
            </button>
          )}
        </div>
      </div>

      {/* Generation Modal */}
      <div id="loader-modal" style={{ width: '100%', height: '100vh', background: 'rgba(0,0,0,0.6)', position: 'fixed', top: '0px', display: showModalLoader, zIndex: 99999 }}>
        <div id="loader-bar-modal" style={{ width: '35vw', padding: '20px', background: 'white', boxShadow: '0px 0px 10px rgba(0,0,0,0.2)', margin: 'auto', marginTop: '50vh', transform: 'translateY(-50%)', borderRadius: '12px' }}>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: 12 }}>
            <Mosaic color="purple" size="small" text="" textColor="white" />
          </div>
          <p id="loader-bar-text" style={{ fontSize: '13px', textAlign: 'center', color: '#555', marginBottom: 12 }}>{taskStatus}</p>
          <div style={{ width: '90%', height: '6px', backgroundColor: '#eee', borderRadius: '5px', margin: 'auto' }}>
            <div style={{ width: longueur, height: '6px', background: 'linear-gradient(90deg, #7C3AED, #a855f7)', borderRadius: '5px', transition: 'width 0.9s ease' }} />
          </div>
          <p style={{ fontSize: '11px', textAlign: 'center', color: '#aaa', marginTop: 10 }}>
            {t("ai-wizard.generation_notice")}
          </p>
        </div>
      </div>

      <ToastContainer position="top-right" autoClose={5000} />
    </>
  );
}